import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/global.css'
import './styles/layout.css'
import App from './App.tsx'
import { Provider } from 'react-redux'
import { store } from './store/store.ts'
import { yandexAuthCallbackRequested } from './store/listeners/yandexAuthCallbackListener.ts'

declare global {
	interface Window {
		django_context?: string
	}
}

// const djangoContext = window.django_context ? JSON.parse(window.django_context) : {};
// console.log('Django Context:', djangoContext);

store.dispatch(yandexAuthCallbackRequested());

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<Provider store={store}>
			<App />
		</Provider>
	</StrictMode>,
)
